export default "__VITE_PUBLIC_ASSET__14d107f6__"